import { createSelector, createStateHook } from 'react-sweet-state';
import { store } from '../../main';
var selectFormMetadata = createSelector(function (state) {
  return state.internalFormMetadata;
}, function (metadata) {
  return metadata;
});
export var useFormMetadata = createStateHook(store, {
  selector: selectFormMetadata
});